module.exports = __webpack_public_path__ + "static/media/trailer-repair.4c107f22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dealerFeatures/trailer-repair.svg
// module id = 2552
// module chunks = 2